// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._27Kvi{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-bottom:1.5rem;font-size:18px;font-size:1.125rem;font-weight:500;line-height:25px;line-height:1.5625rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._2STIO{cursor:pointer}._2je9I{margin-right:.25rem}._12_hA{display:inline-block;width:4px;width:.25rem;height:4px;height:.25rem;background-color:#9fa0a0;border-radius:50%;margin:0 .5rem}._1_oAF{-webkit-transform:translate3d(0,1px,0);transform:translate3d(0,1px,0)}", ""]);
// Exports
exports.locals = {
	"root": "_27Kvi",
	"hasCursor": "_2STIO",
	"star": "_2je9I",
	"dot": "_12_hA",
	"chevron": "_1_oAF"
};
module.exports = exports;
